import React from "react";
import { Box, Typography } from "@mui/material";
import {
    ASSESSMENT_LEGEND,
    ASSESSMENT_RULE_NOTE,
    assessmentCssColor,
} from "utils/assessment";

// 判定（OK / WARNING / NG）の色と意味の凡例。色は表のセルと同じ定義（utils/assessment）から描くので、
// 色を変えても凡例とずれない。hover に頼らず常時表示にして、色が見分けにくい場合も文言で判別できるようにする。
export const AssessmentLegend: React.FC = () => (
    <Box
        role="group"
        aria-label="判定の凡例"
        sx={{ display: "flex", flexDirection: "column", gap: 0.5, mb: 1 }}
    >
        <Box sx={{ display: "flex", flexWrap: "wrap", columnGap: 2.5, rowGap: 0.5 }}>
            {ASSESSMENT_LEGEND.map((item) => (
                <Box key={item.key} sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                    <Box
                        component="span"
                        aria-hidden="true"
                        sx={{
                            width: 14,
                            height: 14,
                            flexShrink: 0,
                            borderRadius: 0.5,
                            border: 1,
                            borderColor: "divider",
                            bgcolor: assessmentCssColor(item.key),
                        }}
                    />
                    <Typography variant="caption" component="span" sx={{ fontWeight: 700 }}>
                        {item.label}
                    </Typography>
                    <Typography variant="caption" component="span" color="text.secondary">
                        {item.description}
                    </Typography>
                </Box>
            ))}
        </Box>
        <Typography variant="caption" color="text.secondary">
            {ASSESSMENT_RULE_NOTE}
        </Typography>
    </Box>
);
